import { CpnPaymentMethod } from '@/utils/cpn'

export interface Payment {
  id: number
  userUuid: string
  quoteUuid: string
  paymentUuid: string
  blockchain: string
  createdAt: string
  delayed: boolean
  expiresAt: string
  failureReason: string | null
  feeAmount: number
  feeCurrency: string
  fiatSettlementMax: number
  fiatSettlementMin: number
  fiatSettlementUnit: string
  fromAmount: number
  fromCurrency: string
  status: string
  toAmount: number
  toCurrency: string
  useCase: string
  paymentMethod: string
  reasonForPayment: string
}

export interface TransferData {
  sendAmount: string
  sendCurrency: string
  receiveAmount: string
  receiveCountry: string
  receiveCurrency: string
  paymentMethod: CpnPaymentMethod
  fees: number
  exchangeRate?: number
}

export interface Transaction {
  id: number
  amount: number
  currency: string
  expiresAt: string
  failureReason: string | null
  paymentId: number
  status: string
  transactionUuid: string
  txHash: string
}

export interface RFI {
  id: number
  status: string
  level: string
  expiresAt?: string
  requiredFields?: Record<string, unknown>
}

export interface PaymentStatusResponse {
  payment: Payment
  transactions: Transaction[]
  rfis: RFI[]
  cadAmount?: number
  message: string
  status: string
}

// ATB Transfer Status Enum
export const ATB_TRANSFER_STATUS = {
  AVAILABLE: 'Available',
  CANCELLED: 'Cancelled',
  COMPLETE: 'Completed',
  DECLINED: 'Declined',
  EXPIRED: 'Expired',
  PROCESSING_EMT: 'Processing direct EMT',
  PROCESSING_RMT: 'Processing fulfilled RMT',
  FULFILLED: 'Fulfilled',
} as const
